import { render } from "./GroupEiProfileParameters.vue?vue&type=template&id=a3860e30&scoped=true"
import script from "./GroupEiProfileParameters.vue?vue&type=script&lang=js"
export * from "./GroupEiProfileParameters.vue?vue&type=script&lang=js"

import "./GroupEiProfileParameters.vue?vue&type=style&index=0&id=a3860e30&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3860e30"]])

export default __exports__